export const CHANGE_DETAILS_SECTION = 'CHANGE_DETAILS_SECTION'
export const CHANGE_DETAILS_UI		= 'CHANGE_DETAILS_UI'
export const ACTIVATE_ACCOMMODATION = 'ACTIVATE_ACCOMMODATION'
export const ACTIVATE_ACTIVITY = 'ACTIVATE_ACTIVITY'
export const ACTIVATE_ACTIVITY_BY_ID = 'ACTIVATE_ACTIVITY_BY_ID'
export const ACTIVATE_ACCOMMODATION_BY_ID = 'ACTIVATE_ACCOMMODATION_BY_ID'
export const ACTIVATE_TRAVEL = 'ACTIVATE_TRAVEL'

export function onChangeDetailsSection(section) {
    return {
        type: CHANGE_DETAILS_SECTION,
        section: section || null
    }
}

export function onChangeDetailsUI(detailSection, detailSubSection, detailSubDetail) {
    return {
        type: CHANGE_DETAILS_UI,
        detailSection: detailSection || null,
        detailSubSection: detailSubSection || null,
        detailSubDetail: detailSubDetail || null
    }
}

export function activateAccommodation(accommodation) {
    return {
        type: ACTIVATE_ACCOMMODATION,
        accommodation: accommodation
    }
}

export function activateActivity(activity) {
    return {
        type: ACTIVATE_ACTIVITY,
        activity: activity
    }
}

export function activateActivityById(activity_id) {
    return {
        type: ACTIVATE_ACTIVITY_BY_ID,
        activity_id: activity_id
    }
}

export function activateAccommodationById(accommodation_id) {
    return {
        type: ACTIVATE_ACCOMMODATION_BY_ID,
        accommodation_id: accommodation_id
    }
}

export function activateTravel(travel) {
    return {
        type: ACTIVATE_TRAVEL,
        travel: travel
    }
}